import { Link } from 'react-router-dom';
import NavBar from '../components/navbar';
import Footer from '../components/footer';

function About() {
    return (
        <>
        <title>About</title>
            {/* Navigation Bar w/NavBurger BEGIN */}
            <NavBar />
            {/* Navigation Bar w/NavBurger End */}

            <main className="">
                <section
                    id="Roger"
                    className="main"
                    style={{
                        marginTop: "px",
                        marginBottom: "-25px",
                        padding: "80px 100px",
                        textAlign: "center"
                    }}
                >
                    <h2>From Tennis and Dentistry, to Ventriloquism!</h2>
                    <p>
                        I've been a dentist my entire adult life but I needed and wanted more.
                        Looking for a new passion I stumbled upon ventriloquism!
                    </p>
                    <p>
                        Even before dentistry I've always believed in pursueing ones passions
                        and gifts. So, I was a Tennis Professional and a Teacher sometime ago,
                        before helping people in Dentistry Field
                    </p>
                    <p>
                        Today I enjoy bringing laughter and joy to children, families and those
                        in need of a friend!
                    </p>
                    <p>
                        I even teach ventiloquism courses at SouthEast Community College.
                        Interested in learning? Ask me{" "}
                        <Link to="/contact" className="link">
                            how.
                        </Link>
                    </p>
                </section>
                <div className="headerwrap">
                    <h1>Meet Tanner!</h1>
                    <Link to="/about">
                        <img
                            className="headerimg"
                            src="/assets/img/tanner.png"
                            alt=""
                        />
                    </Link>
                </div>
                <section
                    id="Tanner"
                    className="main"
                    style={{
                        marginTop: "-25px",
                        marginBottom: "-25px",
                        padding: "1px 25px 30px 25px"
                    }}
                >
                    <h2>"I've got the Scent"</h2>
                    <p>
                        My last life began when my twin brother was born and my master saw him
                        amongts a bunch of puppies! When he came forward he was the one with the
                        'tan ears' and so the two of us were named Tanner. Tanner is a golden
                        doodle! His life was that of a little tiny puppy. My master held out his
                        hands and Tanner my twin ran to him! Fast forward a bit later where my
                        master finds me at the national convention for ventriloquists! My
                        friends were all lined up in a row and one of them was Darcy Lynn’s
                        puppet! I came from her group of friends. My master looked at hundreds
                        of puppets and pick me because I looked like a golden doodle and I had
                        tan ears. You can see that the three of us are like Bobbsey twins and
                        next year we are going to go on tour together two golden doodles and a
                        parrot.
                    </p>
                </section>
                <div className="headerwrap">
                    <h1>Hi Cracker!</h1>
                    <Link to="/about">
                        <img
                            className="headerimg"
                            src="/assets/img/cracker.png"
                            alt=""
                        />
                    </Link>
                </div>
                <section
                    id="Cracker"
                    className="main"
                    style={{ marginTop: "-25px", marginBottom: "-25px", padding: "1px 25px" }}
                >
                    <h2>"Arg! That's what I said"</h2>
                    <table>
                        <tbody>
                            <tr>
                                <td className="two-columns" style={{ direction: "rtl" }}>
                                    <table className="column">
                                        <tbody>
                                            <tr>
                                                <td className="padding">
                                                    <table className="content">
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <img
                                                                        src="/assets/img/crackersbeginning.jp2"
                                                                        alt=""
                                                                        width="100%"
                                                                    />
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table className="column">
                                        <tbody>
                                            <tr>
                                                <td className="padding">
                                                    <table className="content">
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <p>
                                                                        Crackers beginning happen also at the national
                                                                        convention a ventriloquist when my master was
                                                                        talking to the president of the international
                                                                        ventriloquist society and he said he had an old
                                                                        friend that had been with him for years and he
                                                                        was going to retire what is parrot could go on
                                                                        so across the table my master got me without
                                                                        even seeing me and the rest is history.
                                                                    </p>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table>
                        <tbody>
                            <tr>
                                <td className="two-columns">
                                    <table className="column">
                                        <tbody>
                                            <tr>
                                                <td className="padding">
                                                    <table className="content">
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <img
                                                                        src="/assets/img/boulder.jp2"
                                                                        alt=""
                                                                        width="100%"
                                                                    />
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table className="column">
                                        <tbody>
                                            <tr>
                                                <td className="padding">
                                                    <table className="content">
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <p>
                                                                        As you can see by the car that we’re going to
                                                                        travel and do the tour in Boulder not my master
                                                                        purchased with my picture shows we hi I am going
                                                                        to be the talker of the tour i’m special because
                                                                        you know parents sleep at least 12 hours a day
                                                                        so when I see kids quite often I am very sleepy
                                                                        and I just do my thing without talking.
                                                                    </p>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <table>
                        <tbody>
                            <tr>
                                <td className="two-columns" style={{ direction: "rtl" }}>
                                    <table className="column">
                                        <tbody>
                                            <tr>
                                                <td className="padding">
                                                    <table className="content">
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <img
                                                                        src="/assets/img/buddiesinmirror.jpg"
                                                                        alt=""
                                                                        width="100%"
                                                                    />
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table className="column">
                                        <tbody>
                                            <tr>
                                                <td className="padding">
                                                    <table className="content">
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <p>
                                                                        You can see that Tanner and I practice how about
                                                                        anywhere even in the bathroom mirror with my
                                                                        master and Tanner you can see also practices
                                                                        with us even in the kitchen in the living room.
                                                                    </p>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </section>
            </main>
            {/* Footer */}
            <Footer />
            {/* Footer END */}
        </>

    );
}

export default About;